import companyService from "../../services/companyService";
import companyActionTypes from "../types/companyActionTypes";

export const getCompany = () => async (dispatch) => {
    try {
        dispatch({ type: companyActionTypes.START_GET_COMPANY });
        const response = await companyService.getCompany();

        dispatch({
            type: companyActionTypes.GET_COMPANY_SUCCESS,
            payload: response.data,
        });
    }
    catch (error) {
        dispatch({
            type: companyActionTypes.GET_COMPANY_FAILURE,
        });
    }
}

const companyActions = {
    getCompany,
    
}

export default companyActions;